import { CommonModule } from '@angular/common';
import { Component, ViewContainerRef, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css']
})
export class TabsComponent implements OnInit {
  // Configuration for Bootstrap classes
  @Input() config: any = {
    navClass: 'nav nav-pills justify-content-center flex-nowrap',
    tabClass: 'nav-link',
    activeClass: 'active',
    tabContentClass: 'tab-content mt-3',
    tabPaneClass: 'tab-pane fade'
  };

  // Object-based tab structure
  @Input() data: any = {
    UserDetails: {}, // Logged-in user details
    heading: '',
    subHeading: '',
    description: '',
    page: 'Issue',
    searchPageId: '679f3483d2621db98e1d57d0',
    searchPageTitle: 'citizen-issues',
    tabs: [
      {
        name: 'Post',
        pages: ['Issue', 'Job', 'Services']
      },
      {
        name: 'Issue',
        pages: ['Issue', 'Job', 'Services']
      },
      {
        name: 'Announcement',
        pages: ['Issue']
      }
    ]
  };

  selectedTab: string = 'Post'; // Default tab

  constructor(private view: ViewContainerRef) { }

  ngOnInit() {
    try {
      this.data = typeof this.data === 'string' ? JSON.parse(this.data) : this.data;
      this.config = typeof this.config === 'string' ? JSON.parse(this.config) : this.config;
    } catch (error) {
      console.error("Error parsing input data/config:", error);
    }
    console.log("tabData in init", this.data);

    // Ensure data structure exists
    if (!this.data?.tabs) {
      this.data.tabs = []; // Initialize if undefined
    }
    // Agar userId exist karti hai, toh additional tabs add karo
    if (this.data?.UserDetails?.id && this.data?.page) {

      // add all conditions here for myIssue, my jobs, my services etc
      if (this.data.page === 'Issue') {
        this.data.tabs.push({
          name: 'MyPost',
          title: 'My Posts',
          pages: ["Issue"],
          queryParams: {
            issueType: 'Post',
            userId: this.data.UserDetails.id
          }
        });
        this.data.tabs.push({
          name: 'MyIssue',
          title: 'My Issues',
          pages: ["Issue"],
          queryParams: {
            issueType: 'Issue',
            userId: this.data.UserDetails.id
          }
        });
      }
      if (this.data.page === 'Job') {
        this.data.tabs.push({
          name: 'MyJobs',
          title: 'My Jobs',
          pages: ["Job"],
          queryParams: {
            issueType: 'Job',
            userId: this.data.UserDetails.id
          }
        });
      }
      if (this.data.page === 'Services') {
        this.data.tabs.push({
          name: 'MyServices',
          title: 'My Services',
          pages: ["Services"],
          queryParams: {
            issueType: 'Services',
            userId: this.data.UserDetails.id
          }
        });
      }
    }

    // Read the issueType from the URL and update the selectedTab
    this.setTabFromUrl();

    // Listen for browser back/forward navigation events
    window.addEventListener('popstate', () => {
      this.setTabFromUrl();
    });
  }

  setTabFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    let issueType = urlParams.get('issueType');
    const userId = urlParams.get('userId');

    if (userId) {
      issueType = this.data.tabs.find((tab: any) => tab.queryParams.userId && tab.queryParams.issueType == issueType)?.name;
    }

    if (issueType && this.data[issueType.toLowerCase()]) {
      this.selectedTab = issueType;
    } else {
      this.selectedTab = 'Post'; // Default to Post if no issueType is present
    }

  }

  redirectToSelectedTab(tab: any) {
    console.log("Selected Tab:", tab);

    if (this.selectedTab !== tab.name) {
      this.selectedTab = tab.name;

      // Update the URL dynamically without reloading
      const newUrl = `/s/${this.data.searchPageId}/${this.data.searchPageTitle}`;

      let queryParams = tab.queryParams || {issueType: tab.name};
      // Dispatch a custom event
      const customEvent = new CustomEvent('redirect', {
        bubbles: true,
        cancelable: true,
        detail: {
          data: {
            isExternalRedirect: false,
            redirectUrl: newUrl,
            queryParams: JSON.stringify(queryParams)
          }
        }
      });

      console.log('Custom Event:', customEvent);
      this.view.element.nativeElement.dispatchEvent(customEvent);
    }
  }

}
